module.exports = __webpack_public_path__ + "img/badge_color_she-finance.a5d855ce.svg";